export default __webpack_public_path__ + "static/bannerPubliMBPY-a5758115f436082e0589fbac80529dbd.png";